export default {"src":"/_next/static/media/tiktok.3aed15ab.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};